module.exports = __webpack_public_path__ + "img/lv@2x.c0131541.png";